var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E84142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9077 17.8369C32.1754 16.5723 31.0104 16.5723 30.2782 17.8369L16.9809 41.2479C16.2487 42.5291 16.8478 43.5441 18.3123 43.5441H24.9859C26.3339 43.4609 27.5488 42.7454 28.2811 41.614L36.3194 27.6872C36.9018 26.4892 36.9018 25.0748 36.3194 23.8768L33.9229 19.6672L32.9077 17.8369ZM41.746 33.2562C41.0137 31.9917 39.8321 31.9917 39.0998 33.2562L34.4566 41.2596C33.741 42.5241 34.3401 43.5557 35.788 43.5557H44.9746C46.4391 43.5557 47.0383 42.5241 46.306 41.2596L41.746 33.2562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/AVAX.e7d8a8d33661c34665276dcdf9cad5e3.svg";
export { ForwardRef as ReactComponent };